import { Box, Typography } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

import CustomDatePicker from 'components/CustomDatePicker';
import CustomDropdown from 'components/CustomDropdown';
import CustomInput from 'components/CustomInput';

import { Option } from 'types/option.interface';
import { NewCustomerFormData } from 'validation/newCustomerSchema';

interface OthersSectionProps {
  states: Option[];
  control: Control<NewCustomerFormData>;
  isPatientNumberRequired?: boolean;
}

const OthersSection = ({ states, control, isPatientNumberRequired }: OthersSectionProps) => (
  <Box sx={{ flex: 1 }} mt={5} mb={5}>
    <Typography variant="h6" mb={2}>Others</Typography>

    <Box display="flex" flexDirection="column" gap={2}>
      <Controller
        name="driverLicense"
        control={control}
        render={({ field, fieldState }) => (
          <CustomInput
            {...field}
            size="small"
            label="Driver's License Number"
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <Controller
        name="driversLicenseSt"
        control={control}
        render={({ field, fieldState }) => (
          <CustomDropdown
            {...field}
            size="small"
            label="Driver's License State"
            options={states}
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <Controller
        name="driverLicenseExpires"
        control={control}
        render={({ field, fieldState }) => (
          <CustomDatePicker
            {...field}
            size="small"
            label="Driver's License Expiration"
            value={field.value ? new Date(field.value) : null}
            fullWidth
            onChange={(date) => field.onChange(date)}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
      />

      <Controller
        name="patientNumber"
        control={control}
        render={({ field, fieldState }) => (
          <CustomInput
            {...field}
            size="small"
            label="Medical ID"
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            required={isPatientNumberRequired}
          />
        )}
      />

      <Controller
        name="expirationDate"
        control={control}
        render={({ field, fieldState }) => (
          <CustomDatePicker
            {...field}
            value={field.value ? new Date(field.value) : null}
            size="small"
            label="Medical ID Expiration"
            fullWidth
            onChange={(date) => field.onChange(date)}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            required={isPatientNumberRequired}
          />
        )}
      />
    </Box>
  </Box>
);

export default OthersSection;
